import { Type } from "@sinclair/typebox";
import { AVATAR_SEED_MAX, DISPLAY_NAME_MAX } from "../limits";
export const ROOM_CODE_LENGTH = 6;
export const RoomCreateReqSchema = Type.Object({
    display_name: Type.String({ minLength: 1, maxLength: DISPLAY_NAME_MAX }),
    avatar_seed: Type.String({ minLength: 1, maxLength: AVATAR_SEED_MAX }),
});
export const RoomCreateResSchema = Type.Object({
    room_id: Type.String(),
    code: Type.String(),
});
export const RoomJoinReqSchema = Type.Object({
    code: Type.String({ minLength: ROOM_CODE_LENGTH, maxLength: ROOM_CODE_LENGTH }),
    display_name: Type.String({ minLength: 1, maxLength: DISPLAY_NAME_MAX }),
    avatar_seed: Type.String({ minLength: 1, maxLength: AVATAR_SEED_MAX }),
});
export const PlayerSchema = Type.Object({
    user_id: Type.String(),
    display_name: Type.String(),
    avatar_seed: Type.String(),
    connected: Type.Boolean(),
    is_host: Type.Boolean(),
});
export const RoomStateSchema = Type.Object({
    room_id: Type.String(),
    code: Type.String(),
    phase: Type.String(),
    players: Type.Array(PlayerSchema),
    version: Type.Integer(),
});
export const RoomLeaveResSchema = Type.Object({
    left: Type.Boolean(),
});
export const RoomKickReqSchema = Type.Object({
    target_user_id: Type.String(),
});
export const HostTransferReqSchema = Type.Object({
    target_user_id: Type.String(),
});
export const RoomCancelResSchema = Type.Object({
    cancelled: Type.Boolean(),
});
